class ReleaseData {
    automaticInvoicingActive;
    grossAmount;
    ivaAmount;
    ivaPercentage;
    netAmount;
    feeAmount;
    feePercentage;
    releaseAmount;
    releaseWithAutomaticInvoice;
    releaseWithInvoice;
    releaseWithoutInvoice;
    lastAutomaticInvoicingLog;
    constructor(data) {
        this.automaticInvoicingActive = data.automaticInvoicingActive;
        this.grossAmount = data.grossAmount;
        this.ivaAmount = data.ivaAmount;
        this.ivaPercentage = data.ivaPercentage;
        this.netAmount = data.netAmount;
        this.feeAmount = data.feeAmount;
        this.feePercentage = data.feePercentage;
        this.releaseAmount = data.releaseAmount;
        this.releaseWithAutomaticInvoice = data.releaseWithAutomaticInvoice;
        this.releaseWithInvoice = data.releaseWithInvoice;
        this.releaseWithoutInvoice = data.releaseWithoutInvoice;
        this.lastAutomaticInvoicingLog = data.lastAutomaticInvoicingLog ?? undefined;
    }
}
export default ReleaseData;
